import axios from "axios";
import Config from "src/config";

const v1_actionLibraryTemplates = (params = {}) => {
    const { page = 1, limit = 20, category, search } = params;
    
    const queryParams = new URLSearchParams();
    if (page) queryParams.append('page', page);
    if (limit) queryParams.append('limit', limit);
    if (category) queryParams.append('category', category);
    if (search) queryParams.append('search', search);
    
    const queryString = queryParams.toString();
    const url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/library/templates${queryString ? `?${queryString}` : ''}`;
    
    return axios({
        method: "get",
        url
    });
};

export default v1_actionLibraryTemplates;



